/** Maps DB plan slugs to display names */
export const PLAN_DISPLAY_NAMES: Record<string, string> = {
  "Parceiro": "Parceiro",
  "Comece": "Comece",
  "Cresça": "Cresça",
  "Multiplique": "Multiplique",
  "Multiplique II": "Multiplique II",
  "Multiplique Free": "Multiplique Free",
  "Multiplique III": "Multiplique III",
};

export const getPlanDisplayName = (slug: string, fallbackName?: string): string => {
  return PLAN_DISPLAY_NAMES[slug] || fallbackName || slug;
};
